"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importStar(require("styled-components"));
const UserStore_1 = require("../Authentication/lightState/UserStore");
const Avatar_1 = __importStar(require("../Avatar"));
const Grid_1 = __importDefault(require("../icons/Grid"));
const AppLists_1 = __importDefault(require("./AppLists"));
const useClickOutside_1 = __importDefault(require("../hooks/useClickOutside"));
function default_1({ icon }) {
    const [drawerOpen, setDrawerOpen] = react_1.useState(false);
    return (react_1.default.createElement(TopNavigation, { alignItems: "center" },
        react_1.default.createElement(AppsIcon, { onClick: () => setDrawerOpen(true) },
            react_1.default.createElement(Grid_1.default, { width: 18 })),
        drawerOpen && (react_1.default.createElement(DrawerPannel, { onClose: () => setDrawerOpen(false) })),
        icon,
        react_1.default.createElement(rebass_1.Box, { flex: 1 }),
        react_1.default.createElement(TopRight, null,
            react_1.default.createElement(UserProfile, null))));
}
exports.default = default_1;
const DrawerPannel = ({ onClose }) => {
    const ref = react_1.useRef(null);
    useClickOutside_1.default(ref, () => onClose());
    return (react_1.default.createElement(Drawer, { ref: ref },
        react_1.default.createElement(AppLists_1.default, null)));
};
const UserProfile = () => {
    const userinfo = UserStore_1.useStore((state) => state.userinfo);
    return (react_1.default.createElement(UserProfileWrap, null,
        react_1.default.createElement(rebass_1.Text, { fontSize: 13, fontWeight: 500 }, userinfo.name),
        react_1.default.createElement(Avatar_1.default, { size: Avatar_1.AvatarSize.sm, url: userinfo.avatar_url, ml: 2 })));
};
const TopNavigation = styled_components_1.default(rebass_1.Flex) `
    height: 50px;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
    border-bottom: 1px solid #efefef;
    box-sizing: border-box;
`;
const AppsIcon = styled_components_1.default.div `
    width: 50px;
    height: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover {
        background: rgba(150, 150, 150, 0.2);
    }
`;
const AppIconSmall = styled_components_1.default(AppsIcon) `
    width: 44px;
    height: 44px;
    margin: 3px;
`;
const TopRight = styled_components_1.default.div `
    padding: 0 10px;
`;
const UserProfileWrap = styled_components_1.default.div `
    height: 50px;
    display: flex;
    padding: 0 10px;
    align-items: center;
    cursor: pointer;
    :hover {
        background: rgba(150, 150, 150, 0.3);
    }
`;
const drawerFadeIn = styled_components_1.keyframes `
    0% {
        opacity: 0;
        height: 80%;
        width: 300px;
    }
    100% {
        opacity: 100;
        height: 100%;
        width: 360px;   
    }
`;
const Drawer = styled_components_1.default.div `
    position: fixed;
    width: 360px;
    left: 20px;
    top: 20px;
    bottom: 20px;
    border-radius: 15px;
    background: #fff;
    z-index: 999;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
    animation: ${drawerFadeIn} 0.3s;
    overflow-x: hidden;
    padding-top: 20px;
`;
//# sourceMappingURL=index.js.map